import React from 'react';
import { RefreshControl } from 'react-native';

import Text from '../../../components/text/Text';
import { EmptyState, Screen } from '../../../design/components';
import { useRefreshPage } from '../../../hooks';
import { useThemedStyles } from '../../../hooks/useThemedStyles';
import DriverTrainingBanner from '../DriverTrainingBanner';
import { RUN_LOAD_ERROR } from '../driverRoutes';

/**
 * Page frame shared by the start of day step pages: back to Start of day,
 * "Step 3 of 8" in the header, training banner, pull to refresh, loading and
 * the no-run state.
 * Props: day (useDriverDay()), stepLabel, heading, subheading, dock, children.
 */
const StartOfDayStepScreen = ({ day, stepLabel, heading, subheading, dock, children }) => {
	const styles = useThemedStyles(createStyles);
	const [refreshPage, isRefreshing] = useRefreshPage(day.refresh);
	const hasRun = Boolean(day.serviceRun);

	return (
		<Screen
			backLabel="Start of day"
			headerRight={stepLabel ? <Text style={styles.stepLabel}>{stepLabel}</Text> : null}
			heading={hasRun ? heading : undefined}
			subheading={hasRun ? subheading : undefined}
			isLoading={day.isLoading}
			error={day.loadError ? RUN_LOAD_ERROR : undefined}
			onRetry={day.refresh}
			banner={<DriverTrainingBanner />}
			dock={hasRun ? dock : null}
			refreshControl={<RefreshControl refreshing={isRefreshing} onRefresh={refreshPage} />}
		>
			{hasRun ? children : <EmptyState title="No run today" message="This run is no longer assigned to you." />}
		</Screen>
	);
};

const createStyles = ({ ui: { colors, type } }) => ({
	stepLabel: {
		...type.secondary,
		color: colors.textSecondary,
	},
});

export default StartOfDayStepScreen;
